export const
    SetGroup: IGroupSettingsPageSetGroupActionCreator = (groupId) => {
        return {
            type: GROUP_SETTINGS_PAGE_SET_GROUP,
            groupId
        }
    },
    SetTrial: IGroupSettingsPageSetTrialActionCreator = (trialId) => {
        return {
            type: GROUP_SETTINGS_PAGE_SET_TRIAL,
            trialId
        }
    },
    SetTrialGroup: IGroupSettingsPageSetTrialGroupActionCreator = (trialGroupId) => {
        return {
            type: GROUP_SETTINGS_PAGE_SET_TRIALGROUP,
            trialGroupId
        }
    };

export const
    GROUP_SETTINGS_PAGE_SET_GROUP = "GROUP_SETTINGS_PAGE_SET_GROUP",
    GROUP_SETTINGS_PAGE_SET_TRIAL = "GROUP_SETTINGS_PAGE_SET_TRIAL",
    GROUP_SETTINGS_PAGE_SET_TRIALGROUP = "GROUP_SETTINGS_PAGE_SET_TRIALGROUP"

/* Actions */

export interface IGroupSettingsPageSetGroupAction {
    type: "GROUP_SETTINGS_PAGE_SET_GROUP",
    groupId: number;
}

export interface IGroupSettingsPageSetTrialAction {
    type: "GROUP_SETTINGS_PAGE_SET_TRIAL",
    trialId: number;
}

export interface IGroupSettingsPageSetTrialGroupAction {
    type: "GROUP_SETTINGS_PAGE_SET_TRIALGROUP",
    trialGroupId: number;
}

/* Action Creators */

export interface IGroupSettingsPageSetGroupActionCreator {
    (
        groupId: number
    ): IGroupSettingsPageSetGroupAction;
}

export interface IGroupSettingsPageSetTrialActionCreator {
    (
        trialId: number
    ): IGroupSettingsPageSetTrialAction;
}

export interface IGroupSettingsPageSetTrialGroupActionCreator {
    (
        trialGroupId: number
    ): IGroupSettingsPageSetTrialGroupAction;
}


/* Final Export of actions */
export type GroupSettingsPageAction =
    IGroupSettingsPageSetGroupAction |
    IGroupSettingsPageSetTrialAction |
    IGroupSettingsPageSetTrialGroupAction;
